// extracted by mini-css-extract-plugin
export var cartContainer = "_jv-4";
export var gray = "_jv-1";
export var itemContainer = "_jv-2";
export var itemDetails = "_jv-3";
export var strong = "_jv-0";